import { render } from "./Glucotest.vue?vue&type=template&id=e86c1232&scoped=true"
import script from "./Glucotest.vue?vue&type=script&lang=js"
export * from "./Glucotest.vue?vue&type=script&lang=js"

import "./Glucotest.vue?vue&type=style&index=0&id=e86c1232&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e86c1232"]])

export default __exports__